/* Keep marketing overlays from interrupting the seven-step Custom Shop flow. */
(function () {
  'use strict';

  function isCustomShopPopup(dialog) {
    var label = dialog.getAttribute('aria-label') || '';
    var copy = dialog.textContent || '';
    return label === 'POPUP Form' ||
      (copy.indexOf('Obtén 10%OFF') !== -1 && dialog.querySelector('[aria-label="Close dialog"]'));
  }

  function popupOverlay(dialog) {
    var candidate = dialog;
    var node = dialog;

    while (node && node !== document.body) {
      var style = window.getComputedStyle(node);
      var rect = node.getBoundingClientRect();
      if (style.position === 'fixed' &&
        rect.width >= window.innerWidth * 0.8 &&
        rect.height >= window.innerHeight * 0.8) {
        candidate = node;
      }
      node = node.parentElement;
    }

    return candidate;
  }

  function restoreScroll() {
    if (document.querySelector('[data-vv-popup-suppressed="false"]')) return;
    document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
  }

  function suppressPopups(root) {
    var scope = root || document;
    var dialogs = Array.prototype.slice.call(scope.querySelectorAll('[role="dialog"]'));
    if (scope.nodeType === 1 && scope.matches('[role="dialog"]')) dialogs.unshift(scope);
    if (scope.nodeType === 1 && scope.closest('[role="dialog"]')) dialogs.unshift(scope.closest('[role="dialog"]'));
    dialogs.forEach(function (dialog) {
      if (!isCustomShopPopup(dialog) || dialog.dataset.vvPopupSuppressed === 'true') return;
      var overlay = popupOverlay(dialog);
      dialog.dataset.vvPopupSuppressed = 'true';
      overlay.dataset.vvPopupSuppressed = 'true';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('inert', '');
      overlay.style.setProperty('display', 'none', 'important');
      window.requestAnimationFrame(restoreScroll);
    });
  }

  suppressPopups(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) suppressPopups(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}());
